function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
  id: "12knb",
  width: 2,
  height: 2,
  x: -1,
  y: -1
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M7 0h20v16H7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.998 0a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3h-14a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3zm-13.59 2l5.88 5.88a1.004 1.004 0 0 0 1.42 0L23.588 2zm14.59 1.41l-5.88 5.88a3 3 0 0 1-4.24 0l-5.88-5.88V13a1 1 0 0 0 1 .999h14a.999.999 0 0 0 1-1z"
})), /*#__PURE__*/React.createElement("filter", {
  id: "12kna",
  width: 112,
  height: 126,
  x: -39,
  y: -46,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 18,
  in: "SourceGraphic",
  result: "FeOffset1204Out"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "FeOffset1204Out",
  result: "FeGaussianBlur1205Out",
  stdDeviation: "14.4 14.4"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  filter: "url(#12kna)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M23.998 0a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3h-14a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3zm-13.59 2l5.88 5.88a1.004 1.004 0 0 0 1.42 0L23.588 2zm14.59 1.41l-5.88 5.88a3 3 0 0 1-4.24 0l-5.88-5.88V13a1 1 0 0 0 1 .999h14a.999.999 0 0 0 1-1z",
  mask: "url(\"#12knb\")"
}), /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.03,
  d: "M23.998 0a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3h-14a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3zm-13.59 2l5.88 5.88a1.004 1.004 0 0 0 1.42 0L23.588 2zm14.59 1.41l-5.88 5.88a3 3 0 0 1-4.24 0l-5.88-5.88V13a1 1 0 0 0 1 .999h14a.999.999 0 0 0 1-1z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M23.998 0a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3h-14a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3zm-13.59 2l5.88 5.88a1.004 1.004 0 0 0 1.42 0L23.588 2zm14.59 1.41l-5.88 5.88a3 3 0 0 1-4.24 0l-5.88-5.88V13a1 1 0 0 0 1 .999h14a.999.999 0 0 0 1-1z"
})));

var SvgEnvelope = function SvgEnvelope(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "7 0 20 16",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEnvelope, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/envelope.669f8838.svg";
export { ForwardRef as ReactComponent };